import { useSelector } from 'react-redux';

const Can = ({ children, do: I }) => {
  const permissions = useSelector(({ auth }) => auth.permissions);

  return permissions.includes(I) ? children : null;
}

export default Can;